export const REAL_SEND_ENABLED = true;
export const SHOW_GUARDED_EXECUTION_REPORT = false;

// UI-only testing switch for VANGUARD Jackpot interactions.
// This does NOT change contract state and does NOT grant claim rights.
// When enabled, the interface simulates a Jackpot drop to the connected wallet
// after the configured delay so the CLAIM animation/popup flow can be tested.
export const SIMULATE_VANGUARD_JACKPOT_DROP = false;
export const SIMULATED_VANGUARD_JACKPOT_DELAY_MS = 1800;
export const SIMULATED_VANGUARD_JACKPOT_AMOUNT = 777777;

// false = reels start as soon as the lever is pulled.
// true = reels wait until validation/precheck has passed.
export const WAIT_FOR_PRECHECK_OK_BEFORE_SPIN = false;

export const LEVER_SWAP_CONFIG = Object.freeze({
  DEFAULT_SWAP_MULTIPLIER: 1,
  SWAP_MULTIPLIERS: Object.freeze([1, 3, 5, 10, 100]),
  CHAIN_ID: 10,
  CHAIN_ID_HEX: '0xa',
  CHAIN_NAME: 'Optimism Mainnet',
  ROUTER_ADDRESS: '0xAC4c6e212A361c968F1725b4d055b47E63F80b75',
  WETH_ADDRESS: '0x4200000000000000000000000000000000000006',
  PR_ADDRESS: '0xc756C791268D7C2728113A2Ff48cA46548200906',
  PAIR_ADDRESS: '0x2a0e0e256425BC5152eD19949c2Ee740AEA2F672',
  NATIVE_ADDRESS: '0xEeeeeEeeeEeEeeEeEeEeeEEEeeeeEeeeeeeeEEeE',
  PERMIT2_ADDRESS: '0x000000000022d473030f116ddee9f6b43ac78ba3',
  SUSHI_SWAP_API_BASE: 'https://api.sushi.com/swap/v7',
  SLIPPAGE_FACTOR: 0.35,
  BUY_FACTOR: 1.13,
  MAX_QUOTE_DEVIATION_BPS: 1000,
  REAL_SEND_ENABLED,
  DRY_RUN_ONLY: !REAL_SEND_ENABLED,
  SHOW_GUARDED_EXECUTION_REPORT,
  WAIT_FOR_PRECHECK_OK_BEFORE_SPIN,
  SIMULATE_VANGUARD_JACKPOT_DROP,
  SIMULATED_VANGUARD_JACKPOT_DELAY_MS,
  SIMULATED_VANGUARD_JACKPOT_AMOUNT,
});
